'use client'

import useCommonStore from '@/store/commonStore'
import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect, useRef, useState } from 'react'



interface SortByProps {
  open: boolean
  onClose: () => void,
}


export function SortBy({ open, onClose, }: SortByProps) {
  const modalRef = useRef<HTMLDivElement>(null)
  const router = useRouter()
  const searchParams = useSearchParams()
  const { sortData,translations } = useCommonStore()
  const [selected, setSelected] = useState({ key: "", value: "" })
  const handleApply = (key?: string, value?: string) => {
    const sp = new URLSearchParams()
    searchParams.forEach((v, k) => {
      if (!k.startsWith('s_')) {
        sp.set(k, v)
      }
    })
    if (key && value) {
      sp.set(`s_${key}`, value)
    } else if (key && !value) {
      sp.delete(`s_${key}`)
    } else {
      searchParams.forEach((value, key) => {
        if (key.startsWith('s_')) {
          sp.delete(key)
        }
      })
      setSelected({ key: "", value: "" })
    }
    router.replace(`?${sp.toString()}`)
    onClose()
  }

  useEffect(() => {
    searchParams?.forEach((value, key) => {
      if (key.startsWith("s_")) {
        const filterKey = key.slice(2)
        setSelected({ key: filterKey, value })
      } else {
        setSelected({ key: "", value: "" })
      }
    })
  }, [searchParams])

  // Close on outside click
  useEffect(() => {
    if (!open) return
    function handleClick(e: MouseEvent) {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [open, onClose])

  // Prevent background scroll when modal is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [open])

  if (!open) return null

  return (
    <div className="absolute  w-full h-screen z-50 flex items-start justify-center bg-black/30 transition-colors">
      <div
        ref={modalRef}
        className="w-full max-w-md bg-white rounded-b-2xl p-6 animate-slideDown"
      >
        <div className='flex items-center justify-between mb-4'>
          <div className="text-sm text-gray-400  font-semibold">{translations["sort_by"] || "SORT BY"}</div>
          <div onClick={() => handleApply()} className="text-sm text-gray-400 underline">{translations["clear"] || "Clear"}</div>
        </div>
        <div className="space-y-4">
          {sortData.map((option, index) => (
            <label
              key={index}
              className="flex items-center justify-between cursor-pointer"
            >
              <span className="text-sm">{option.label}</span>
              <input
                type="radio"
                name="sort"
                checked={selected.key === option.key && selected.value === option.value}
                onChange={() => handleApply(option.key, option.value)}
                className="accent-primary w-4 h-4"
              />
            </label>
          ))}
        </div>
      </div>
      <style jsx global>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slideUp {
          animation: slideUp 0.3s cubic-bezier(0.4,0,0.2,1);
        }
      `}</style>
    </div>
  )
}